if (!customElements.get('component-header-accordion')) {

    class HeaderAccordion extends HTMLElement {
        constructor() {
            super();

            this.toggleAccordion = this.toggleAccordion.bind(this)
            this.content = this.nextElementSibling;
            this.onlyMobile = !!this.hasAttribute('only-mobile');
            this.size = 990;

        }

        connectedCallback() {

            this.addEventListener('click', this.toggleAccordion.bind(this), true);

            if (this.onlyMobile) {
                this.onlyMobileSet();
                window.addEventListener("resize", this.onlyMobileSet.bind(this));
            }

            const allAccordions = document.querySelectorAll('component-footer-accordion');
            if (allAccordions[0] === this) {
                this.open = true;
            }
        }

        static get observedAttributes() {
            return ['open'];
        }

        get open() {
            return this.hasAttribute('open');
        }

        set open(isOpen) {
            if (isOpen) {
                this.setAttribute('open', '');
                this.content.style.maxHeight = this.content.scrollHeight + "px";

            } else {
                this.removeAttribute('open');
                this.content.style.maxHeight = null;
            }
        }

        toggleAccordion() {
            this.open = !this.open;
        }

        onlyMobileSet() {
            if (!window.matchMedia(`(max-width:${this.size}px`).matches) {
                this.open = false;
            }

        }
    }

    customElements.define('component-header-accordion', HeaderAccordion);

}
